export default __webpack_public_path__ + "static/quote-8-d5356bc2c6b73fb52f06cc5d83f9c8a5.mp3";